import * as i0 from '@angular/core';
import * as i1 from './tags.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '../common/auto-focus.directive';
import * as i5 from '../common/template-loader.component';
import * as i6 from '../common/resizeable.directive';
import * as i7 from '../common/dropdown.directive';
import * as i8 from './tags.component';
import * as i9 from '../common/trust-html.pipe';
import * as i10 from '../common/date.pipe';
import * as i11 from '../common/common.module';
export const TagsModuleNgFactory:i0.NgModuleFactory<i1.TagsModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_r = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_bd = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bf = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i4.AutoFocusDirective = (<any>(null as any));
var _decl0_33:i5.TemplateLoaderComponent = (<any>(null as any));
var _decl0_34:i6.ResizeableDirective = (<any>(null as any));
var _decl0_35:i7.DropdownDirective = (<any>(null as any));
var _decl0_36:i8.TagsComponent = (<any>(null as any));
var _decl0_37:i2.AsyncPipe = (<any>(null as any));
var _decl0_38:i2.UpperCasePipe = (<any>(null as any));
var _decl0_39:i2.LowerCasePipe = (<any>(null as any));
var _decl0_40:i2.JsonPipe = (<any>(null as any));
var _decl0_41:i2.SlicePipe = (<any>(null as any));
var _decl0_42:i2.DecimalPipe = (<any>(null as any));
var _decl0_43:i2.PercentPipe = (<any>(null as any));
var _decl0_44:i2.TitleCasePipe = (<any>(null as any));
var _decl0_45:i2.CurrencyPipe = (<any>(null as any));
var _decl0_46:i2.DatePipe = (<any>(null as any));
var _decl0_47:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_48:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_49:i2.KeyValuePipe = (<any>(null as any));
var _decl0_50:i9.TrustHtmlPipe = (<any>(null as any));
var _decl0_51:i10.DatePipe = (<any>(null as any));
var _decl0_52:i2.CommonModule = (<any>(null as any));
var _decl0_53:i3.FormsModule = (<any>(null as any));
var _decl0_54:i11.RebirthCommonModule = (<any>(null as any));
var _decl0_55:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_56:i0.ElementRef<any> = (<any>(null as any));
function _View_TagsComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_TagsComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'tags ',_decl0_36.cssClass,'');
  currVal_0;
  const currVal_1:any = _decl0_36.mutipleItems;
  currVal_1;
  const currVal_2:any = (!_decl0_36.disabled && !_decl0_36.isTyping);
  currVal_2;
  const currVal_3:any = (!_decl0_36.disabled && _decl0_36.isTyping);
  currVal_3;
}
